module.exports = __webpack_public_path__ + "static/media/konsistent.d8a5ce7d.svg";